import type { IsoDateRange } from "@/utils/date";

/**
 * The plain-language filter the Filters drawer offers on the inbox and the
 * contacts list - the same axes the query builder can express, without asking
 * anyone to build a rule. Every field is a facet: they AND together, and an
 * empty one is simply absent.
 */
export interface QuickFilterValue {
  followUp: FollowUpFilter;
  assignees: string[];
  tags: string[];
  /** Treatments on the contact's profile (clinics). Products is the ecommerce twin. */
  treatments: string[];
  products: string[];
  /** Clinic only: departments of the treatments on the contact. */
  departments: string[];
  channels: string[];
  createdAt: IsoDateRange;
  /** Last inbound/outbound activity - `lastBumpedAt` on the contact. */
  lastActiveAt: IsoDateRange;
}

export const FOLLOW_UP_FILTER = {
  ANY: "any",
  DUE: "due",
  SCHEDULED: "scheduled",
  NONE: "none",
} as const;

export type FollowUpFilter =
  (typeof FOLLOW_UP_FILTER)[keyof typeof FOLLOW_UP_FILTER];

/**
 * URL params the drawer owns. They are deliberately the same on both surfaces,
 * so one parser serves the inbox and the contacts list and a link means the same
 * thing wherever it is pasted. `followUp` predates the drawer as the contacts
 * sidebar's Follow-ups row and keeps that meaning.
 */
export const QUICK_FILTER_PARAM = {
  FOLLOW_UP: "followUp",
  ASSIGNEES: "assignees",
  TAGS: "tags",
  TREATMENTS: "treatments",
  PRODUCTS: "products",
  DEPARTMENTS: "departments",
  CHANNELS: "channels",
  CREATED_FROM: "createdFrom",
  CREATED_TO: "createdTo",
  ACTIVE_FROM: "activeFrom",
  ACTIVE_TO: "activeTo",
} as const;
